import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'app-plus-minus-button-widget',
  templateUrl: './plus-minus-button-widget.component.html',
  styleUrls: ['./plus-minus-button-widget.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    FormlyModule,
    ReactiveFormsModule,
  ]
})
export class PlusMinusButtonWidgetComponent extends FieldType {

  constructor() {
    super();
  }

  plus() {
    let l = +this.formControl.value;
    this.formControl.setValue(l + 1);
  }

  minus() {
    let l = +this.formControl.value;
    this.formControl.setValue(l - 1);
  }

}
